module.exports = "/static/079c1eab61ec269fb51b50ce4acd79e9.png";